export default __webpack_public_path__ + "assets/models/8a3e1e88361a6d8c75f6299dd106f9a2.glb";